import { InitializeAcc, Profile, UserClassification } from '@Models/types';

export const isProfile = (profile: false | Profile): profile is Profile =>
  profile !== false;

export function getUserClassification(
  user: InitializeAcc | null
): UserClassification {
  if (!user || !user.profile) return 'none';

  const { aha_api_key, testrail_api_key, testrail_username } = user.profile;

  const hasAha = !!aha_api_key;
  const hasTestRail = !!testrail_api_key && !!testrail_username;

  if (!hasAha && !hasTestRail) return 'no-api';
  if (hasAha && !hasTestRail) return 'only-aha';
  if (!hasAha && hasTestRail) return 'only-testrail';

  return 'both';
}
